/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { clip } from './util.js';
import { jQuery } from '../other/jquery-hooked.js';


export function getPreferedMaxDialogWidth() {
	return clip( jQuery('#page-head').innerWidth(), 240, 4800 );
}

export function getPreferedMaxDialogHeight() {
	var mh = jQuery('#page-right,#page-single').innerHeight()||0,
		hh1 = jQuery('#page-head').innerHeight()||0,
		hh2 = jQuery('#page-menu-1').innerHeight()||0;
	return clip( mh + Math.max(hh1,hh2)/2, 180, 3600 );
}

export function dialogDynWidthFn( min, max ) {
	if( typeof min === 'undefined' || min==='auto' ) {
		return function(win_size) {
			return 'auto';
		};
	}
	return function(win_size) {
		return clip( getPreferedMaxDialogWidth()-40, min, max );
	};
}

export function dialogDynHeightFn( min, max ) {
	if( typeof min === 'undefined' || min==='auto' ) {
		return function(win_size) {
			return 'auto';
		};
	}
	return function(win_size) {
		return clip( getPreferedMaxDialogHeight()+0, min, max );
	};
}

export function closeDialog( elem, destroy, initiating_evt ) {
	if( initiating_evt && initiating_evt.type==='keydown' && initiating_evt.which===27 ) {
		if( window.MVPageDebug && window.MVPageDebug.isVisible() ) {
			// dont close dialog! but allow #dprint code to handle the keydown event ...
			return false;
		}
	}
	// jquery ui would throw error when trying to call close() on element that is not (or no longer) a dialog widget
	if( elem!==null && typeof elem!=='undefined' ) {
		for( var i=0; i<elem.length; ++i ) {
			var ie = elem[i];
			if( jQuery.data(ie,'ui-dialog') ) jQuery(ie).dialog( destroy ? 'destroy' : 'close' );
			else if( jQuery.data(ie,'jqueryUiExtendeddialog') ) jQuery(ie).extendeddialog( destroy ? 'destroy' : 'close' );
		}
	}
	return true;
}




function getScrollTopForScrollingElementIntoView( elm, cnt, missing_offset, snap_to_top_px_range, offset_bottom ) {
	if( !elm || !elm.length ) return;
	missing_offset = missing_offset ?? 0;
	offset_bottom = offset_bottom ?? 0;
	var elmT = elm[0].offsetTop + missing_offset,
		elmB = elmT + parseInt(elm.height()||0,10),
		cntT = cnt.scrollTop(),
		cntH = parseInt(cnt.height()||0,10) - offset_bottom,
		cntB = cntT + cntH,
		s = null,
		i, e, t, b;
	for( i=1; i<elm.length; ++i ) {
		e = elm[i];
		t = e.offsetTop + missing_offset - 1;
		if( t<elmT ) elmT = t;
		b = t + (jQuery(e).height()||0) + 2;
		if( b>elmB ) elmB = b;
	}
	if( elmB<cntT ) {
		s = elmT;
	} else if( elmT<cntT && elmB>=cntT && elmB<cntB ) {
		s = elmT;
	} else if( elmT>=cntT && elmB>=cntT && elmB<cntB ) {
		/* no-op */
	} else if( elmT>=cntT && elmT<cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT>=cntT && elmT>=cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT<cntT && elmB>=cntB ) {
		/* no-op */
	}
	if( s!==null && snap_to_top_px_range && s<=snap_to_top_px_range ) s = 0; // snap to top
	return s;
}


export function getScrollLeftForScrollingElementIntoView( elm, cnt, missing_offset, snap_to_left_px_range, offset_right ) {
	if( !elm || !elm.length ) return;
	missing_offset = missing_offset ?? 0;
	offset_right = offset_right ?? 0;
	var elmT = elm[0].offsetLeft + missing_offset,
		elmB = elmT + parseInt(elm.width()||0,10),
		cntT = cnt.scrollLeft(),
		cntH = parseInt(cnt.width()||0,10) - offset_right,
		cntB = cntT + cntH,
		s = null,
		i, e, t, b;
	for( i=1; i<elm.length; ++i ) {
		e = elm[i];
		t = e.offsetLeft + missing_offset - 1;
		if( t<elmT ) elmT = t;
		b = t + (jQuery(e).width()||0) + 2;
		if( b>elmB ) elmB = b;
	}
	if( elmB<cntT ) {
		s = elmT;
	} else if( elmT<cntT && elmB>=cntT && elmB<cntB ) {
		s = elmT;
	} else if( elmT>=cntT && elmB>=cntT && elmB<cntB ) {
		/* no-op */
	} else if( elmT>=cntT && elmT<cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT>=cntT && elmT>=cntB && elmB>=cntB ) {
		s = elmB-cntH+1;
		if( elmT<s && elmB>=s ) s = elmT;
	} else if( elmT<cntT && elmB>=cntB ) {
		/* no-op */
	}
	if( s!==null && snap_to_left_px_range && s<=snap_to_left_px_range ) s = 0; // snap to left
	return s;
}






export function scrollElementIntoView( elm, cnt, missing_top_offset, snap_to_top_px_range, offset_bottom ) {
	const scrollTop = getScrollTopForScrollingElementIntoView(elm,cnt,missing_top_offset,snap_to_top_px_range,offset_bottom);
	if( scrollTop!==null ) cnt.scrollTop(scrollTop);
}


export function scrollElementIntoViewHoriz( elm, cnt, missing_left_offset, snap_to_left_px_range ) {
	const scrollLeft = getScrollLeftForScrollingElementIntoView(elm,cnt,missing_left_offset,snap_to_left_px_range);
	if( scrollLeft!==null ) cnt.scrollLeft(scrollLeft);
}


/**
 * Like scrollElementIntoView(), but may modify vertical and horizontal scrolling as-well.
 *
 * NOTE: Calling scrollElementIntoView() first, followed by scrollElementIntoViewHoriz()
 * may cause performance issues:
 *  Its the reflow:
 *  - a first call (scrollElementIntoView) will ask the browser for positions and sizes, and thus may cause reflow.
 *  - And when that information is available, and after computing the new scroll offset, the code will probably alter the scroll offset.
 *  - Now comes the second call (scrollElementIntoViewHoriz), it too will ask for positions and sizes, but now this will very likely
 *    cause just another reflow! Because we only just have modified the scroll offset ..
 *  - .. and so on.
 *
 *  - also see https://firefox-source-docs.mozilla.org/performance/bestpractices.html
 *
 *  Alternative: scrollElementIntoView2() should avoid that problem.
 *
 *
 * @param {*} elm 							The element that should become visible to the user.
 * @param {*} cnt 							The scroll container (usually declared by CSS overflow:auto).
 * @param {*} missing_top_offset			Size of an eventual "gap" between top of scroll container and element coordinates.
 * 											E.g. think of a <div> scroll container, containing other elements and a <table>, which contains many <td>s,
 * 											and we'd like to scroll the container so that such <td>s become visible: missing_top_offset value here should be
 * 											<table>.offsetTop - or the distance from <table>s upper edge to scroll containers upper edge (before scrolled).
 * @param {*} missing_left_offset			See missing_top_offset.
 * @param {*} snap_to_top_px_range
 * @param {*} snap_to_left_px_range
 */
export function scrollElementIntoView2( elm, cnt, missing_top_offset, missing_left_offset, snap_to_top_px_range, snap_to_left_px_range ) {
	const scrollTop = getScrollTopForScrollingElementIntoView(elm,cnt,missing_top_offset,snap_to_top_px_range);
	const scrollLeft = getScrollLeftForScrollingElementIntoView(elm,cnt,missing_left_offset,snap_to_left_px_range);
	if( scrollTop!==null ) cnt[0].scrollTop = scrollTop;
	if( scrollLeft!==null ) cnt[0].scrollLeft = scrollLeft;
}

export function scrollElementIntoView3( elm_top, elm_left, cnt, missing_top_offset, missing_left_offset, snap_to_top_px_range, snap_to_left_px_range, offset_bottom, offset_right ) {
	const scrollTop = getScrollTopForScrollingElementIntoView(elm_top,cnt,missing_top_offset,snap_to_top_px_range,offset_bottom);
	const scrollLeft = getScrollLeftForScrollingElementIntoView(elm_left,cnt,missing_left_offset,snap_to_left_px_range,offset_right);
	if( scrollTop!==null ) cnt[0].scrollTop = scrollTop;
	if( scrollLeft!==null ) cnt[0].scrollLeft = scrollLeft;
}




export function focusFirstElement( container, tabbable_only, exclude_hidden_inputs, exclude_buttons, use_autofocus, focus_last_element ) {
	var tmp, candidates;
	if( use_autofocus && (tmp=container.find('[autofocus]')).length ) candidates = tmp;
	else candidates = container.find(':input,span.string-label').filter(':visible:'+(tabbable_only?'tabbable':'focusable'));
	if( exclude_hidden_inputs ) candidates = candidates.not('[type="hidden"]');
	if( exclude_buttons ) candidates = candidates.not(':button');
	let first = candidates.eq(focus_last_element?-1:0);
	if( first.length ) {
		if( first[0].nodeName==='INPUT' && first.attr('type')==='radio' ) {
			if( (tmp=first.siblings(':checked')).length ) first = tmp.eq(focus_last_element?-1:0);
		} else if( first[0].nodeName==='SELECT' ) {
			if( first.data('select2') ) {
				return first.select2('focus');
			}
		}
		return first.trigger('focus');
	}
	return null;
}


